import { render } from "./card-form-mp.vue?vue&type=template&id=5086b7a2&scoped=true"
import script from "./card-form-mp.vue?vue&type=script&lang=js"
export * from "./card-form-mp.vue?vue&type=script&lang=js"

import "./card-form-mp.vue?vue&type=style&index=0&id=5086b7a2&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5086b7a2"]])

export default __exports__